"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyErrorPage = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_i18next_1 = require("react-i18next");
const SurveyErrorPage = (props) => (react_1.default.createElement("div", { className: "survey", style: { display: 'block' }, id: "surveyErrorPage" },
    react_1.default.createElement("div", { className: "apptr__form" },
        react_1.default.createElement("span", { className: "_large _strong _blue" },
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.t(['survey:AnErrorOccurred', 'AnErrorOccurred']) } }))),
    react_1.default.createElement("div", { className: "apptr__separator" }),
    react_1.default.createElement("div", { className: "apptr__form" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: props.t(['survey:MakeSureReliableConnection', 'MakeSureReliableConnection'])
            } })),
    react_1.default.createElement("div", { className: "apptr__separator" }),
    react_1.default.createElement("div", { className: "apptr__form" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.t(['survey:ErrorPersistsWhatToDo', 'ErrorPersistsWhatToDo']) } })),
    react_1.default.createElement("div", { className: "apptr__separator" }),
    react_1.default.createElement("div", { className: "apptr__form" },
        react_1.default.createElement(react_router_1.Link, { to: "/survey", onClick: props.onRedirect }, props.t(['survey:BackToSurveyPage', 'BackToSurveyPage'])))));
exports.SurveyErrorPage = SurveyErrorPage;
exports.default = (0, react_i18next_1.withTranslation)(['main'])(exports.SurveyErrorPage);
//# sourceMappingURL=SurveyErrorPage.js.map